import { Stack, Typography } from '@mui/material'
import { Indent } from 'api'
import { SettingsItem } from 'components/global'
import { Dialog } from 'elements/feedback'
import { useBoolean } from 'lib/hooks'
import { useTranslation } from 'react-i18next'

import { EditProjectIndentForm } from './edit-project-indent-form'

type ProjectIndentBlockProps = {
  projectId: string
  indent: Indent
}

export const ProjectIndentBlock = ({
  projectId,
  indent,
}: ProjectIndentBlockProps) => {
  const { t } = useTranslation()

  const isOpen = useBoolean()

  return (
    <>
      <SettingsItem
        title={t('projects.settings.indents.indents')}
        onClick={isOpen.setTrue}
      >
        <Stack>
          <Typography variant="caption2">{`${t(
            'projects.settings.indents.json_indent',
          )}: ${indent.json}`}</Typography>

          <Typography variant="caption2">
            {`${t('projects.settings.indents.xml_indent')}: ${indent.xml}`}
          </Typography>
        </Stack>
      </SettingsItem>

      <Dialog open={isOpen.isTrue} onClose={isOpen.setFalse}>
        <EditProjectIndentForm
          projectId={projectId}
          indent={indent}
          onClose={isOpen.setFalse}
        />
      </Dialog>
    </>
  )
}
